export const CORES_OPERADORAS = {
    1:  '#00aeef', // Cielo - Azul
    2:  '#ff7800', // Redecard - Laranja
    3:  '#e60000', // Santander Getnet - Vermelho
    4:  '#71b0da', // Elavon - Azul
    5:  '#055761', // Sipag - Azul
    6:  '#004f80', // Bin - Azul
    7:  '#00622a', // Banese - Verde
    8:  '#4179bc', // American Express - Azul
    9:  '#fad207', // Rede Ipiranga
    10: '#2e2871', // Ticket
    11: '#229127', // Dacasa - Verde
    12: '#3dab57', // Stone - Verde
    13: '#9c1b16', // LiberCard - Vermelho
    14: '#3541b1', // Sodexo -Roxo
    15: '#f7903b', // Sodexo Frota - Laranja
    16: '#0153b2', // Vale Card - Rosa
    17: '#aab4bb', // Senff - Cinza
    18: '#75b226', // PagSeguro - Verde
    19: '#6bac7c', // Green Card - Verde
    20: '#f4ae00', // Good Card - Amarelo
    21: '#b4d22d', // Ticket Car - Verde
    22: '#5e6e6d', // Up Plan - Cinza
    23: '#ace0f0', // Nutricash - Azul
    24: '#87754d', // VR Benefícios - Marrom
    25: '#c22433', // FitCard - Vermelho
    26: '#1f1a17', // Expers -
    27: '#007db3', // PayPal - Azul
    28: '#769b31', // Vero - Verde
    30: '#7936F5', // Stelo - Roxo
    31: '#008C38', // BNDES - Verde
    32: '#007f61', // Alelo - Verde
    33: '#001C78', // Saude Service
    34: '#232933', // Sumup - Azul
    35: '#c1d731', // Banescard - Verde
    36: '#0e2040', // Policard - Azul
    37: '#006b3f', // Brasilcard - Verde
    38: '#0055a2', // Bigcard - Azul
    39: '#0086a2', // Acqio - Azul
    40: '#02538b', // Cabal - Azul
    41: '#62c233', // Sicredi - Verde
    42: '#00477f', // Global Payments - Azul
    43: '#d10011'  // Comprocard - Vermelho
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/shared/cores-operadoras.const.ts